import { Injectable } from '@angular/core';
import { Http,Response , Headers } from '@angular/http';

import { Config } from '../../config/config';
import { VnptHttpService } from '../services/vnpt-http.service';
import { TaiKhoan } from './tai-khoan';
@Injectable()
export class TaiKhoanService {

    controller:string = 'NhanVien';
    constructor(private http: Http) { }

    GetUserDetails() {
        let headers = new Headers();
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller+'/GetUserDetails', { headers: headers }).map(resp => resp.json());
               
    }
}



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/thong-tin-tai-khoan/tai-khoan.service.ts